// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"494":"07cba13a","853":"7ed776f8","869":"d7b72bf2","873":"300a83bb"}[chunkId] + ".css";
};